var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps-item"},[_c('div',{staticClass:"steps-item-num-wrapper",class:{
      'steps-item-num-wrapper__inactive': !_vm.isActived,
      'steps-item-num-wrapper__pass': _vm.isPass && _vm.isChecked
    }},[_c('div',{staticClass:"steps-item-num",class:{
        'steps-item-num__inactive': !_vm.isActived
      }},[(!_vm.isChecked)?[_vm._v("\n        "+_vm._s(_vm.num)+"\n      ")]:(_vm.isPass && _vm.isChecked)?[_c('img',{staticClass:"check-icon",attrs:{"src":_vm.checkIcon,"alt":"check"}})]:(!_vm.isPass && _vm.isChecked)?[_c('img',{staticClass:"fail-icon",attrs:{"src":_vm.failIcon,"alt":"fail"}})]:_vm._e()],2)]),_c('div',{staticClass:"steps-item-desc",class:{
      'steps-item-desc__inactive': !_vm.isActived,
      'steps-item-num-wrapper__fail': !_vm.isPass && _vm.isChecked
    }},[_vm._v("\n    "+_vm._s(_vm.desc)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }